import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'
import { AUTH_USER } from 'constants/AuthConstant';

export const APP_NAME = 'Bomba';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const API_PATH_URL = env.API_BASE_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const getAuthenticatedEntry = () => {
  const rawUser = localStorage.getItem(AUTH_USER);
  const user = rawUser ? JSON.parse(rawUser) : null;
  
  if (user?.master_name === 'Jabatan Bomba') {
    return `${APP_PREFIX_PATH}/dashboardbomba`;
  } else if (user?.master_name === 'Master Pyroserve Sdn Bhd') {
    return `${APP_PREFIX_PATH}/dashboardfitters`;
  } else if (user?.master_name === 'Developer') {
    return `${APP_PREFIX_PATH}/tetapan/bangunan`;
  }
  return `${APP_PREFIX_PATH}/dashboard`;
};
export const UNAUTHENTICATED_ENTRY = '/login'

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
